// Auto-layout for /works/deeper/:slug. Simple 2-column alternating grid.
// Position units: x in vw%, y in vh, w in vw.
//
// VW_TO_VH: 1vw expressed in vh on a 16:9 viewport (16/9 ≈ 1.778).
// Used to convert image width + ratio → image height in vh, so consecutive
// same-column images are placed below each other without overlap.
// Over-estimates height on narrower viewports (safe) and under-estimates on
// ultra-wide (21:9+); WorkDetail.jsx corrects further by measuring actual
// naturalHeight/naturalWidth per image after load.

const COLS_X = [8, 50];
const CARD_W = 44;
const TOP_VH = 8;
const GAP_VH = 8;
export const VW_TO_VH = 16 / 9;

const PAGE_HEIGHT_FLOOR_VH = 240;
export const PAGE_HEIGHT_TAIL_VH = 30;

/**
 * @param {number} count
 * @param {number} [_descriptionAtVh] - kept for API compat, no longer used for image placement
 * @param {Array<number|undefined>} [ratios] - naturalHeight/naturalWidth per image; falls back to 1.5 (portrait)
 * @param {number} [vwToVh] - actual viewport width/height ratio; defaults to 16/9
 */
export function layoutWorkDetail(count, _descriptionAtVh = 112, ratios = [], vwToVh = VW_TO_VH) {
  if (!count || count < 1) return [];
  const positions = [];
  const nextY = [TOP_VH, TOP_VH];
  for (let i = 0; i < count; i++) {
    const col = i % 2;
    const y = nextY[col];
    positions.push({ x: COLS_X[col], y, w: CARD_W });
    const ratio = typeof ratios[i] === "number" ? ratios[i] : 1.5;
    nextY[col] = y + CARD_W * vwToVh * ratio + GAP_VH;
  }
  return positions;
}

export function workDetailPageHeightVh(count, _descriptionAtVh = 112, ratios = [], vwToVh = VW_TO_VH) {
  if (!count || count < 1) return PAGE_HEIGHT_FLOOR_VH;
  const nextY = [TOP_VH, TOP_VH];
  let maxBottom = TOP_VH;
  for (let i = 0; i < count; i++) {
    const col = i % 2;
    const y = nextY[col];
    const ratio = typeof ratios[i] === "number" ? ratios[i] : 1.5;
    const h = CARD_W * vwToVh * ratio;
    maxBottom = Math.max(maxBottom, y + h);
    nextY[col] = y + h + GAP_VH;
  }
  return Math.max(PAGE_HEIGHT_FLOOR_VH, maxBottom + PAGE_HEIGHT_TAIL_VH);
}
